import { combineReducers } from 'redux';

const allReducer = combineReducers({
	
})

export default allReducer;